import { createContext } from 'react';

const CommonMarginLeftContext = createContext('0');

export default CommonMarginLeftContext;
